import React from 'react';
import styled from '@emotion/styled';
import { shade, tint } from 'polished';

type Props = {
  id: string,
  className: ?string,
  checked: boolean,
  onChange: Function,
  onClick?: Function,
};

export const Switch = ({ id, className, onClick, onChange, checked }: Props) => {
  return (
    <Wrapper className={className}>
      <Input type="checkbox" id={`switch-input-${id}`} name="off-switch" checked={checked} onChange={onChange} />
      <Label onClick={onClick} data-test="switch-input" htmlFor={`switch-input-${id}`} />
    </Wrapper>
  );
};

const Wrapper = styled('div')`
  position: relative;
  display: flex;
  align-items: center;
`;

const Label = styled('label')`
  cursor: pointer;
  position: relative;
  width: 72px;
  height: 40px;

  &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background: ${({ theme }) => theme.color.lightGrey};
    border-radius: ${({ theme }) => theme.borderRadius.ellipse};
    transition: ${({ theme }) => theme.motion.transition};
  }

  &::after {
    content: '';
    position: absolute;
    width: 32px;
    height: 32px;
    border-radius: ${({ theme }) => theme.borderRadius.circle};
    background: ${({ theme }) => theme.color.white};
    top: 4px;
    left: 4px;
    transition: ${({ theme }) => theme.motion.transition};
  }

  &:hover {
    &::before {
      background: ${({ theme }) => shade(0.05, theme.color.lightGrey)};
    }
    &::after {
      box-shadow: ${({ theme }) => theme.boxShadow.small};
    }
  }

  &:active {
    &::before {
      background: ${({ theme }) => tint(0.5, theme.color.brand)};
    }
  }
`;

const Input = styled('input')`
  width: 0;
  opacity: 0;

  &:checked ~ ${Label} {
    &::before {
      background: ${({ theme }) => theme.color.brand};
    }
    &::after {
      left: auto;
      transform: translateX(36px);
    }
  }
`;

Switch.defaultProps = {
  className: null,
};
